import React, { useState, useEffect } from "react";
import axios from "axios";

const Usuarios = () => {
    const [iframeUrl, setIframeUrl] = useState("");

    useEffect(() => {
        // Reemplaza con la URL de tu endpoint
        const fetchIframeUrl = async () => {
            try {
                const response = await axios.get("https://quickview.rskgroupco.com/app/quickview/boxtoken");
                setIframeUrl(response.data); // Asegúrate de que 'url' sea el campo correcto
            } catch (error) {
                console.error("Error al obtener la URL del iframe:", error);
            }
        };

        fetchIframeUrl();
    }, []);

    return (
        <div>
            <h1>Usuarios</h1>
            {iframeUrl ? (
                <iframe
                    src={iframeUrl}
                    frameBorder="0"
                    width="100%"
                    height="1024"
                    allowTransparency="true"
                    style={{ border: "none" }}
                ></iframe>
            ) : (
                <p>Cargando...</p>
            )}
        </div>
    );
};

export default Usuarios